import {createTheme} from '@mui/material/styles';
import './Recursos/CitrusGothic-Regular.otf'


export const theme = createTheme({
    palette: {
        primary: {
            main: "#BA0008",
        },
        secondary: {
            main: "#F0EFD8",
        },
        info: {
            main: "#000",
        },
        success: {
            main: "#9E9DA2"
        },
        action: {
            main: "#FFF"
        }

    },
    typography: {
        fontFamily: ['Montserrat','sans-serif'].join(','),
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
                color: "secondary"
            },
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    fontWeight: 600,
                    paddingRight: 60,
                    paddingLeft: 60,
                    fontSize: 20,
                    textTransform: "none",
                    color: "#BA0008"
                },

            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#BA0008"
                }
            }
        }

    }


})
